import Vue from "vue";
import Router from "vue-router";
import Troubleshoot from "@/components/troubleshoot";
import Privacy from "@/components/privacy";
import UserProtocol from "@/components/userprotocol";
import FindIndex from "@/components/find/index";
import FindDetail from "@/components/find/detail";
import ExperIndex from "@/components/exper/index";
import SoloUserP from "@/components/solo/user";
import SoloPrivacy from "@/components/solo/privacy";
import SoloSmart from "@/components/solo/smart";

import EnService from "@/components/en/service_agreement";
import EnUser from "@/components/en/user_agreement";

import Service from "@/components/service";
import UserAndP from "@/components/userandp";
import ActiveHelp from "@/components/activehelp";
import Intelligent from "@/components/intelligent";
import IntelligentEn from "@/components/intelligent_en";

import Help from "@/components/help/home";
import HelpIndex from "@/components/help/index";
import Trouble from "@/components/help/trouble";

// blueshark国际版 帮助中心
import MultilingualHelp from "@/components/help_multilingual/home";
import MultilingualHelpIndex from "@/components/help_multilingual/index";
import MultilingualTrouble from "@/components/help_multilingual/trouble";

import battswapPayTest from "@/components/battswap/payTest";

// blueshark
// battswap 换电服务
import bsPayState from "@/components/blueshark/battswap/pay/paystate";
import bsPayWay from "@/components/blueshark/battswap/pay/payway";
import bsMenuList from "@/components/blueshark/battswap/menu/menulist";
import bsMenuDetail from "@/components/blueshark/battswap/menu/menudetail";
import bsMenuOpen from "@/components/blueshark/battswap/menu/menuopen";
import bsMyMenuList from "@/components/blueshark/battswap/mymenu/mymenulist";
import bsMyMenuDetail from "@/components/blueshark/battswap/mymenu/mymenudetail";
import bsBillDetail from "@/components/blueshark/battswap/mybill/billdetail";
import bsCurrentBill from "@/components/blueshark/battswap/mybill/currentbill";
import bsHistoryBill from "@/components/blueshark/battswap/mybill/historybill";
import bsSelMenuList from "@/components/blueshark/battswap/mymenu/selmenulist";

// 换电服务协议
import bsBattswapPrivacy from "@/components/blueshark/privacy/battswapprivacy";
// import bsBattswapPrivacy from '@/components/blueshark/privacy/battswapprivacy'

// solo
// 协议和帮助中心
// 欧洲
// 协议英文
import slEnServiceAgreement from "@/components/solo/en/agreement/serviceagreement";
import slEnPrivacyPolicy from "@/components/solo/en/agreement/privacypolicy";
// 帮助中心英文
import slEnHelp from "@/components/solo/en/helpcenter/home";
import slEnHelpIndex from "@/components/solo/en/helpcenter/index";
// 台湾
// 协议英文
import slTwServiceAgreement from "@/components/solo/tw/agreement/serviceagreement";
import slTwPrivacyPolicy from "@/components/solo/tw/agreement/privacypolicy";
// 帮助中心繁文
import slTwHelp from "@/components/solo/tw/helpcenter/home";
import slTwHelpIndex from "@/components/solo/tw/helpcenter/index";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/app/troubleshoot/:tcode",
      component: Troubleshoot
    },
    {
      path: "/app/privacy",
      component: Privacy
    },
    {
      path: "/app/userprotocol",
      component: UserProtocol
    },
    {
      path: "/app/find/index",
      component: FindIndex
    },
    {
      path: "/app/find/detail/:id",
      component: FindDetail
    },
    {
      path: "/app/exper/index",
      component: ExperIndex
    },
    {
      path: "/solo/userprotocol",
      component: SoloUserP
    },
    {
      path: "/solo/privacy",
      component: SoloPrivacy
    },
    {
      path: "/solo/smartservice",
      component: SoloSmart
    },
    {
      path: "/app/en/serviceagreement",
      component: EnService
    },
    {
      path: "/app/en/useragreement",
      component: EnUser
    },
    {
      path: "/bs/serviceagreement",
      component: Service
    },
    {
      path: "/bs/useragreement",
      component: UserAndP
    },
    {
      path: "/bs/intelligent",
      component: Intelligent
    },
    {
      path: "/bs/en/intelligent",
      component: IntelligentEn
    },
    {
      path: "/bs/activehelp/:id",
      component: ActiveHelp
    },
    {
      path: "/bs/help",
      component: Help
    },
    {
      path: "/bs/help/:ti",
      component: HelpIndex
    },
    {
      path: "/bs/help/:ti/:qi",
      component: HelpIndex
    },
    {
      path: "/bs/trouble/:ti",
      component: Trouble
    },
    // 换电帮助
    {
      path: "/bs/:lang/help/exAssistance",
      component: () =>
        import("../components/help_multilingual/exAssistance/index.vue")
    },
    {
      path: "/bs/:lang/help/exAssistance/:ti",
      component: () =>
        import(
          "../components/help_multilingual/exAssistance/selectSubtitle.vue"
        )
    },
    {
      path: "/bs/:lang/help/exAssistance/:ti/:subti",
      component: () =>
        import(
          "../components/help_multilingual/exAssistance/exAssistanceInfo.vue"
        )
    },
    {
      path: "/bs/:lang/help",
      component: MultilingualHelp
    },
    {
      path: "/bs/:lang/help/quickGuide",
      component: () => import("../components/help_multilingual/quickGuide")
    },
    {
      path: "/bs/:lang/help/quickGuide/:ti",
      component: () =>
        import("../components/help_multilingual/selectModelGuide")
    },
    {
      path: "/bs/:lang/help/quickGuide/:ti/:model",
      component: () => import("../components/help_multilingual/quickGuideInfo")
    },
    {
      path: "/bs/:lang/help/:ti",
      component: MultilingualHelpIndex
    },
    {
      path: "/bs/:lang/help/:ti/:qi",
      component: MultilingualHelpIndex
    },
    {
      path: "/bs/:lang/trouble/:ti",
      component: MultilingualTrouble
    },
    {
      path: "/bs/battswap/paystate",
      component: bsPayState
    },
    {
      path: "/bs/battswap/menulist",
      component: bsMenuList
    },
    {
      path: "/bs/battswap/menudetail/:id",
      component: bsMenuDetail
    },
    {
      path: "/bs/battswap/menuopen",
      component: bsMenuOpen
    },
    {
      path: "/bs/battswap/mymenulist",
      component: bsMyMenuList
    },
    {
      path: "/bs/battswap/mymenudetail/:id",
      component: bsMyMenuDetail
    },
    {
      path: "/bs/battswap/billdetail/:id",
      component: bsBillDetail
    },
    {
      path: "/bs/battswap/currentbill",
      component: bsCurrentBill
    },
    {
      path: "/bs/battswap/historybill",
      component: bsHistoryBill
    },
    {
      path: "/battswap/payTest",
      component: battswapPayTest
    },
    {
      path: "/bs/battswap/payway",
      component: bsPayWay
    },
    {
      path: "/bs/battswap/selmenulist/:id",
      component: bsSelMenuList
    },
    {
      path: "/bs/battswap/privacy",
      component: bsBattswapPrivacy
      // solo sl 所乐
    },
    {
      path: "/sl/en/agreement/serviceagreement",
      component: slEnServiceAgreement
    },
    {
      path: "/sl/en/agreement/privacypolicy",
      component: slTwPrivacyPolicy
    },
    {
      path: "/sl/en/help",
      component: slEnHelp
    },
    {
      path: "/sl/en/help/:ti",
      component: slEnHelpIndex
    },
    {
      path: "/sl/en/help/:ti/:qi",
      component: slEnHelpIndex
    },
    {
      path: "/sl/tw/agreement/serviceagreement",
      component: slTwServiceAgreement
    },
    {
      path: "/sl/tw/agreement/privacypolicy",
      component: slEnPrivacyPolicy
    },
    {
      path: "/sl/tw/help",
      component: slTwHelp
    },
    {
      path: "/sl/tw/help/:ti",
      component: slTwHelpIndex
    },
    {
      path: "/sl/tw/help/:ti/:qi",
      component: slTwHelpIndex
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js